export default __webpack_public_path__ + "static/media/lovearecipe.f558b8ff.png";